<template>
  <div class="account">
    <Map
      class="map"
      :taskPoint="taskPoint"
      @close="closaShowMap"
      :style="{ width: isShowInfoList ? 'calc(100% - 620px)' : 'calc(100% - 310px)' }"
      v-loading="mapLoading"
      element-loading-text="地图加载中，请稍等..."
    ></Map>
    <div class="list">
      <!-- 搜索 -->
      <div class="top"><div class="title">林长巡林列表</div></div>
      <div class="search">
        区域：
        <el-select size="mini" v-model="searchFrom.areaId" @change="changeArea" placeholder="请选择区域" style="width: 224px" filterable>
          <el-option v-for="item in AreaData1" :key="item.areaId" :label="item.areaName" :value="item.areaId"></el-option>
        </el-select>
        用户：
        <el-select size="mini" v-model="searchFrom.userCode" @change="selectTask" placeholder="请选择用户" style="margin-top: 16px; width: 224px" filterable>
          <el-option v-for="item in patrolUserList" :key="item.userCode" :label="item.userName" :value="item.userCode"></el-option>
        </el-select>

        <!-- <el-date-picker
          style="width: 100%; margin-top: 16px"
          v-model="date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectDate"
          value-format="yyyy-MM-dd"
          size="mini"
          clearable
        ></el-date-picker> -->

        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin-top: 16px">
          <el-date-picker v-model="searchFrom.startTime" type="date" placeholder="开始日期" style="width: 45%" size="mini" value-format="yyyy-MM-dd" @change="selectDate"></el-date-picker>
          <span>-</span>
          <el-date-picker v-model="searchFrom.endTime" type="date" placeholder="结束日期" style="width: 45%" size="mini" value-format="yyyy-MM-dd" @change="selectDate"></el-date-picker>
        </div>

        <!-- <el-button style="margin-left:32px;" type="primary" @click="selectTask">搜 索</el-button> -->
      </div>
      <!-- 表格 -->
      <div class="table">
        <div class="check_all">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-button size="mini" type="text" style="margin-left: 15px" @click="exportXLLog">导出巡林日志</el-button>
          <el-button size="mini" type="text" style="margin-left: 15px" @click="exportXLLog2">导出巡林次数</el-button>
        </div>
        <div style="margin-top: 50px" v-loading="loading" element-loading-text="数据加载中...">
          <div style="display: flex; align-items: center" v-for="(item, index) in taskList" :key="item.Id" class="item">
            <el-checkbox v-model="item.checked" @change="clickTackCheck"></el-checkbox>
            <div class="task_name" @click="clickRow(item, index)" :style="{ color: activateId == item.Id ? '#409EFF' : '' }">
              {{ item.name }}
            </div>
            <el-button size="mini" style="margin-left: 8px" @click="lookDetail(item, 2)">详情</el-button>
            <el-button size="mini" style="margin-left: 8px" @click="lookDetail(item, 1)">修改</el-button>
          </div>
        </div>
      </div>
      <!-- 翻页 -->
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 巡林详情 -->
    <el-dialog :title="detailForm.name" :visible.sync="detailModal2" width="600px" :before-close="() => (detailModal2 = false)">
      <el-scrollbar style="height: 500px" ref="scrollbar" wrap-style="overflow-x:hidden;">
        <el-form :model="detailForm" label-width="100px">
          <el-form-item label="林长" style="flex: 1">
            <span>{{ detailForm.userName }}</span>
          </el-form-item>
          <el-form-item label="巡林时间" style="flex: 1">
            <span>{{ detailForm.creationTime }}</span>
          </el-form-item>
          <el-form-item label="巡林地点">
            <span>{{ detailForm.location }}</span>
          </el-form-item>
          <el-form-item label="参与人员">
            <span>{{ detailForm.participants }}</span>
          </el-form-item>
          <el-form-item label="巡林主题">
            <span>{{ detailForm.content }}</span>
          </el-form-item>
          <el-form-item label="巡林详情">
            <span>{{ detailForm.resolvent }}</span>
          </el-form-item>
          <el-form-item label="巡林照片">
            <div v-if="detailForm.imgs && detailForm.imgs.length > 0">
              <showImages :imgs="detailForm.imgs" :ids="detailForm.images"></showImages>
            </div>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="detailModal2 = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 巡林详情编辑 -->
    <el-dialog :title="detailForm.name" :visible.sync="detailModal" width="600px" :before-close="() => (detailModal = false)">
      <el-scrollbar style="height: 500px" ref="scrollbar" wrap-style="overflow-x:hidden;">
        <el-form :model="detailForm" label-width="100px">
          <el-form-item label="林长" style="flex: 1">
            <span>{{ detailForm.userName }}</span>
          </el-form-item>
          <el-form-item label="巡林时间" style="flex: 1">
            <span>{{ detailForm.creationTime }}</span>
          </el-form-item>
          <el-form-item label="巡林地点">
            <el-input v-model="detailForm.location"></el-input>
          </el-form-item>
          <el-form-item label="参与人员">
            <el-input v-model="detailForm.participants"></el-input>
          </el-form-item>
          <el-form-item label="巡林主题">
            <el-input v-model="detailForm.content"></el-input>
          </el-form-item>
          <el-form-item label="巡林详情">
            <el-input v-model="detailForm.resolvent"></el-input>
          </el-form-item>
          <el-form-item label="巡林照片">
            <el-upload
              accept=".jpg,.png"
              action="#"
              :auto-upload="false"
              :limit="10"
              :file-list="fileList"
              list-type="picture-card"
              :on-exceed="handleExceed"
              :on-change="handlePreview"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="closeDetailModal">关 闭</el-button>
        <el-button type="success" @click="UpdateForester">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 打卡点详情信息（移入展示弹窗） -->
    <div class="move_box" v-show="isShowMoveBox" ref="move_box">
      <div style="font-weight: bold">{{ pointInfo.name }}</div>
      <div style="margin-top: 8px" v-if="pointInfo.type == 2">{{ pointInfo.problemType }}</div>
      <div style="margin-top: 8px" v-if="pointInfo.type == 2">巡林内容：{{ pointInfo.content }}</div>
      <div style="margin-top: 8px" v-if="pointInfo.imagess && pointInfo.imagess.length > 0">
        <showImages :imgs="pointInfo.imgs" :ids="pointInfo.imagess"></showImages>
      </div>
    </div>
  </div>
</template>

<script>
  import { GetPatrolUserName, GetPatrolRoute, GetPatroRouteByIds, GetPatroRouteDetailsById, GetPatrolsContentByPatrolsIds } from '../../api/Message'
  import Map from '../messageManage/components/map.vue'
  import showImages from '@/components/showImage'
  import {
    GetTaskAreaBox,
    GetForesterUserByArea,
    GetForesterPatrolLis,
    GetForesterPatrolDetails,
    GetForesterPatroByIds,
    DownXLRZZip,
    DownXLCountExcel,
    UpdateMyForesterPatrol,
    UploadImage,
  } from '@/api/Forester'
  import request from '@/utils/axios'
  import { baseUrl2 } from '@/static/utils/lyconfig'
  export default {
    name: 'foresterPatrol',
    components: {
      Map,
      showImages,
    },
    data() {
      return {
        // 巡林人列表
        patrolUserList: [
          {
            userCode: '-1',
            userName: '全部',
          },
        ],
        // 任务列表搜索表单
        searchFrom: {
          areaId: -1,
          pageNumber: 1,
          pageSize: 20,
          userCode: '-1',
          startTime: '',
          endTime: '',
        },
        // 搜索的开始时间结束时间
        date: '',
        total: 100, // 数据总数
        currentPage: 1, // 当前页数
        pageSize: 20, // 当前查询数据个数
        // 任务列表
        taskList: [],
        // 加载状态
        loading: false,
        // 是否展示地图
        showMap: false,
        // 任务路线打卡点
        taskPoint: [],
        // 被选择的任务打卡数组
        selectTaskPointList: [],
        // 被选中的任务ID
        selectTaskId: [],
        // 打卡点详情弹窗
        pointInfoDialogShow: false,
        // 当前打卡点详情
        pointInfo: {},
        // 是否展示打卡列表
        isShowInfoList: false,
        // 打卡记录列表标题
        title: '',
        // 打卡记录列表数据
        PatrolInfo: [],
        // 打卡上报弹窗展示状态
        reportDialog: false,
        // 区域数据
        AreaData1: [],
        // 上报表单
        reportFrom: {
          id: -1,
          // 流程节点Id
          flowchartNodeId: null,
        },
        // 打卡记录列表id
        activateId: -1,
        // 打卡记录标题
        activateName: '',
        // 执法编辑弹窗展示状态
        detailModal: false,
        // 执法详情弹窗展示状态
        detailModal2: false,
        // 执法详情
        detailForm: {},
        fileList: [], //照片
        // 巡林任务是否全选
        checkAll: false,
        // 巡林任务是否未未知状态（既没有全选，也没有全不选）
        isIndeterminate: false,
        // 当前页面所有巡林id的集合
        allId: [],
        // 打卡记录点id
        activatePointId: -1,
        // 是否展示移动弹窗
        isShowMoveBox: false,
        // 地图加载等待状态
        mapLoading: true,
        // 巡林上报对应的事件
        eventList: [],
        isSelectAll: false, //是否全选
      }
    },
    computed: {
      patrolPointId() {
        return this.$store.state.patrolPointId
      },
    },
    watch: {
      patrolPointId(val) {
        if (val != -1) {
          this.selectPointInfo(val)
        } else {
          this.isShowMoveBox = false
        }
      },
      // 修改激活的打卡记录点
      activatePointId(val) {
        this.showPoint({ id: val })
      },
    },
    mounted() {
      this.getMapState()
      this.selectTask()
      this.getArea(1)
      this.changeArea(-1)
    },
    methods: {
      async UpdateForester() {
        const that = this
        let imageIds = []
        let formData = new FormData()
        that.fileList.forEach((item) => {
          if (item.raw) {
            formData.append('files', item.raw)
          } else {
            imageIds.push(item.uid)
          }
        })
        if (that.fileList.length != imageIds.length) {
          await UploadImage(formData).then((res) => {
            if (res.data.state == 1) {
              let ids = JSON.parse(res.data.data)
              imageIds.push(...ids)
            }
          })
        }

        let params = {
          id: that.detailForm.id,
          resolvent: that.detailForm.resolvent,
          location: that.detailForm.location,
          participants: that.detailForm.participants,
          content: that.detailForm.content,
          resolvent: that.detailForm.resolvent,
          imageIds: JSON.stringify(imageIds),
        }

        await UpdateMyForesterPatrol(params).then((res) => {
          if (res.data.state == 1) {
            that.$message({
              message: '成功！',
              type: 'success',
            })
            that.closeDetailModal()
          } else {
            that.$message.error(res.data.msg)
          }
        })
      },
      //关闭详情窗口
      closeDetailModal() {
        this.detailModal = false
        this.fileList = []
      },
      // 上传文件
      handlePreview(file) {
        console.log('handlePictureCardPreview', file)
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
        const extension1 = testmsg === 'jpg'
        const extension2 = testmsg === 'png'
        if (!extension1 && !extension2) {
          return this.$message.warning('请上传jpg或png类型文件!')
        } else {
          this.fileList.push({ name: file.name, raw: file.raw, url: file.url })
        }
        this.dialogImageUrl = file.url
      },
      //移除文件
      handleRemove(file, fileList) {
        this.fileList = fileList
      },
      //超出上传文件数警告
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 10 个文件`)
      },
      // 点击巡林任务多选框
      clickTackCheck() {
        // 获取被勾选的图层id数组
        let checkList = []
        this.taskList.forEach((item) => {
          if (item.checked) {
            checkList.push(item.id)
          }
        })
        if (checkList.length == this.taskList.length) {
          this.isSelectAll = true
        } else {
          this.isSelectAll = false
        }
        if (checkList.length > 0) {
          // 绘制巡林图层
          this.drawLayerByIDs({ ids: checkList })
        } else {
          // 清空图层
          this.clearAllLayer()
        }
        // 根据勾选状态修改全选按钮展示状态
        if (checkList.length == 0) {
          this.checkAll = false
          this.isIndeterminate = false
        } else if (this.allId.length == checkList.length) {
          this.checkAll = true
          this.isIndeterminate = false
        } else {
          this.checkAll = false
          this.isIndeterminate = true
        }
      },
      // 导出巡林日志
      exportXLLog() {
        // 获取被勾选的图层id数组
        let checkList = []
        this.taskList.forEach((item) => {
          if (item.checked) {
            checkList.push(item.id)
          }
        })
        if (checkList.length == 0) {
          return this.$message.warning('请选择要导出的数据')
        }
        let params = {
          ids: checkList,
          startTime: this.searchFrom.startTime,
          endTime: this.searchFrom.endTime,
          areaId: this.searchFrom.areaId,
          userCode: this.searchFrom.userCode,
          isSelectAll: this.isSelectAll,
        }

        DownXLRZZip(params).then((res) => {
          console.log(res)
          let blob = new Blob([res.data], { type: 'application/xlsx' }) // response就是接口返回的文件流
          console.log(blob)
          let objectUrl = URL.createObjectURL(blob)
          console.log(blob, objectUrl)
          const link = document.createElement('a') // 创建a标签
          link.href = objectUrl
          link.download = '林长巡林统计表.xlsx' // 自定义文件名
          link.click() // 下载文件
          URL.revokeObjectURL(objectUrl) // 释放内存
        })
      },
      // 导出巡林次数
      exportXLLog2() {
        DownXLCountExcel(this.searchFrom).then((res) => {
          console.log(res)
          let blob = new Blob([res.data], { type: 'application/xlsx' }) // response就是接口返回的文件流
          console.log(blob)
          let objectUrl = URL.createObjectURL(blob)
          console.log(blob, objectUrl)
          const link = document.createElement('a') // 创建a标签
          link.href = objectUrl
          link.download = '林长巡林次数汇总表.xlsx' // 自定义文件名
          link.click() // 下载文件
          URL.revokeObjectURL(objectUrl) // 释放内存
        })
      },
      // 点击巡林任务全选按钮
      handleCheckAllChange(val) {
        this.isSelectAll = val
        this.taskList.forEach((item) => {
          item.checked = val
        })
        // 关闭未知状态
        this.isIndeterminate = false
        if (val) {
          this.drawLayerByIDs({ ids: this.allId })
        } else {
          // 清空所有图层
          this.clearAllLayer()
        }
      },
      // 根据选择任务id，绘制对应图层内容
      drawLayerByIDs(ids) {
        // 获取勾选的所以任务路线
        GetForesterPatroByIds(ids).then((res) => {
          if (res.data.data.length > 0) {
            let esriModule = this.$store.state.esriModule
            let lineLayer = map.getLayer('lineLayer')
            // 如果没有线图层，则新建线图层
            if (lineLayer == undefined) {
              lineLayer = new esriModule.GraphicsLayer({
                id: 'lineLayer',
              })
              map.addLayer(lineLayer, 10)
            } else {
              lineLayer.clear()
            }
            res.data.data.forEach((task) => {
              // 添加线(巡林路线)
              let POINTLIST = []
              POINTLIST = JSON.parse(task.geo)
              const allLine = new esriModule.Graphic({
                geometry: { paths: [POINTLIST] },
                symbol: { color: [255, 198, 65], width: 2, type: 'esriSLS', style: 'esriSLSSolid' },
              })
              lineLayer.add(allLine)
            })
          } else {
            this.clearAllLayer()
          }
        })
        GetPatrolsContentByPatrolsIds(ids).then((res) => {
          if (res.data.state == 1) {
            this.$store.commit('setAllFellableInfo', res.data.data)
          }
        })
      },
      // 清空所有图层
      clearAllLayer() {
        // 巡林图层
        let lineLayer = map.getLayer('lineLayer')
        if (lineLayer) {
          lineLayer.clear()
        }
      },
      // 关闭上报弹窗
      handleClose() {
        this.reportFrom = {
          id: -1,
          flowchartNodeId: null,
        }
        this.reportDialog = false
      },
      // 获取区域数据
      getArea(type) {
        GetTaskAreaBox(type).then((res) => {
          if (res.data.state == 1) {
            if (type == 1) {
              this.AreaData1 = res.data.data
            } else if (type == 2) {
              this.AreaData2 = res.data.data
            }
          }
        })
      },
      // 区域数据更改
      changeArea(areaId) {
        this.searchFrom.userCode = '-1'
        this.patrolUserList = []
        this.selectTask()
        GetForesterUserByArea(areaId).then((res) => {
          if (res.data.state == 1) {
            this.patrolUserList = res.data.data
          }
        })
      },
      // 获取所有巡林人
      getAllPatrolUser() {
        GetPatrolUserName().then((res) => {
          this.patrolUserList = JSON.parse(res.data.data)
          this.patrolUserList.unshift({
            UserCode: '-1',
            UserName: '全部',
          })
        })
      },
      // 选择日期
      selectDate(value) {
        // if (value) {
        //   this.searchFrom.startTime = value[0]
        //   this.searchFrom.endTime = value[1]
        // } else {
        //   this.searchFrom.startTime = ''
        //   this.searchFrom.endTime = ''
        // }
        this.selectTask()
      },
      // 查询任务列表数据
      selectTask() {
        this.loading = true
        this.searchFrom.pageNumber = this.currentPage
        this.searchFrom.pageSize = this.pageSize
        GetForesterPatrolLis(this.searchFrom).then((res) => {
          this.loading = false
          let data = res.data.data
          this.allId = []
          data.lis.forEach((d) => {
            d.checked = false
            this.allId.push(d.id)
          })
          this.taskList = data.lis
          this.total = data.count
          this.checkAll = false
          this.isIndeterminate = false
          this.clearAllLayer()
        })
      },
      // 修改页码
      handleSizeChange(e) {
        this.pageSize = e
        this.selectTask()
      },
      // 修改每页展示条数
      handleCurrentChange(e) {
        this.currentPage = e
        this.selectTask()
      },
      // 关闭地图展示
      closaShowMap() {
        this.showMap = false
      },
      // 查询打卡路径GetPatrolRoute
      selectPoint(id) {
        let params = {
          pageNumber: 1,
          pageSize: 999,
          patrolsId: id,
        }
        GetPatrolRoute(params).then((res) => {
          if (JSON.parse(res.data.data).Lis.length == 0) {
            this.$message.error('当前任务暂无打卡，请稍后重试')
            return
          } else {
            this.showMap = true
            this.taskPoint = JSON.parse(res.data.data).Lis
          }
        })
      },
      //勾选表格多选框
      handleSelectionChange(item) {
        let params = {
          ids: [],
        }
        item.forEach((element) => {
          params.ids.push(element.id)
        })
        // 获取勾选的所以任务路线
        GetPatroRouteByIds(params).then((res) => {
          if (res.data.data.length > 0) {
            let esriModule = this.$store.state.esriModule
            let pointLayer = map.getLayer('pointLayer')
            let polygonLayer = map.getLayer('polygonLayer')
            // 如果没有线图层，则新建线图层
            if (pointLayer == undefined) {
              pointLayer = new esriModule.GraphicsLayer({
                id: 'pointLayer',
              })
            } else {
              pointLayer.clear()
            }
            // 如果没有面图层，则新建面图层
            if (polygonLayer == undefined) {
              polygonLayer = new esriModule.GraphicsLayer({
                id: 'polygonLayer',
              })
            } else {
              polygonLayer.clear()
            }
            res.data.data.forEach((task) => {
              let POINTLIST = []
              task.forEach((ele) => {
                POINTLIST.push(JSON.parse(ele.Point))
                if (ele.Geo) {
                  let myPolygon = {
                    geometry: { rings: [JSON.parse(ele.Geo)], spatialReference: map.spatialReference },
                    symbol: {
                      color: [250, 53, 52, 80],
                      outline: { color: [255, 204, 51, 255], width: 5, type: 'esriSLS', style: 'esriSLSSolid' },
                      type: 'esriSFS',
                      style: 'esriSFSSolid',
                    },
                  }
                  // 添加面(问题反馈图形)
                  const Polygon = new esriModule.Graphic(myPolygon)
                  polygonLayer.add(Polygon)
                }
              })
              // 添加线(巡林路线)
              const allLine = new esriModule.Graphic({
                geometry: { paths: [POINTLIST] },
                symbol: { color: [255, 198, 65], width: 2, type: 'esriSLS', style: 'esriSLSSolid' },
              })
              pointLayer.add(allLine)
              task.forEach((t) => {
                let loc = JSON.parse(t.Point)
                var pt = new esriModule.Point(loc[0], loc[1], map.spatialReference)
                var sms = new esriModule.SimpleMarkerSymbol({
                  color: t.Type == 2 ? [216, 30, 6] : [18, 150, 219],
                  size: 10,
                  type: 'esriSMS',
                  style: 'esriSMSCircle',
                })
                const Point = new esriModule.Graphic(pt, sms, { id: t.id })
                pointLayer.add(Point)
              })
            })
            map.addLayer(pointLayer)
            map.addLayer(polygonLayer)
          } else if (res.data.data.length == 0) {
            let pointLayer = map.getLayer('pointLayer')
            if (pointLayer) {
              pointLayer.clear()
            }
            let polygonLayer = map.getLayer('polygonLayer')
            if (polygonLayer) {
              polygonLayer.clear()
            }
            let imagePointLayer = map.getLayer('imagePointLayer')
            if (imagePointLayer) {
              imagePointLayer.clear()
            }
          }
        })
      },
      // 获取详情巡林详情
      lookDetail(row, type) {
        GetForesterPatrolDetails(row.id).then((res) => {
          if (res.data.state == 1) {
            this.detailForm = res.data.data
            if (this.detailForm.images.length > 0) {
              let arr2 = []
              this.fileList = []
              this.detailForm.images.forEach((item) => {
                item.SmallPath = this.$store.state.imgUrl + item.id
                arr2.push(this.$store.state.imgUrl + item.id)
                this.fileList.push({ uid: item.id, name: item.name, url: this.$store.state.imgUrl + item.id })
              })
              this.detailForm.imgs = arr2
            }
            if (type == 1) {
              this.detailModal = true
            } else {
              this.detailModal2 = true
            }
          }
        })
      },
      // 巡林任务被点击
      clickRow(row, index) {
        // 点击任务名称时，则取消其余任务的勾选
        this.taskList.forEach((item) => {
          if (item.id == row.id) {
            item.checked = true
          } else {
            item.checked = false
          }
        })
        this.activatePointId = -1
        this.clickTackCheck()
        this.moveMap(row)
      },
      moveMap(row) {
        // 地图跳转至对应巡林位置
        let params = {
          pageNumber: 1,
          pageSize: 9999,
          patrolsId: row.id,
        }

        GetForesterPatrolDetails(row.id).then((res) => {
          if (res.data.state == 1) {
            if (res.data.data.geo !== '[]') {
              let esriModule = this.$store.state.esriModule
              let P = JSON.parse(res.data.data.geo)[0]
              let point = new esriModule.Point(P[0], P[1], map.spatialReference)
              map.centerAndZoom(point, 15)
            } else {
              this.$message.warning('暂无巡林路线数据')
            }
          }
        })
        // GetPatrolRoute(params).then(res => {
        // 	if (JSON.parse(res.data.data).Lis.length > 0) {
        // 		let esriModule = this.$store.state.esriModule;
        // 		let P = this.computedExtent(JSON.parse(res.data.data).Lis);
        // 		let point = new esriModule.Point(P[0], P[1], map.spatialReference);
        // 		map.centerAndZoom(point, 15);
        // 	} else {
        // 		this.$message.warning('暂无打卡数据');
        // 	}
        // });
      },
      // 计算范围中心点
      computedExtent(pointList) {
        let xmin,
          ymin,
          xmax,
          ymax = 0
        let x, y
        if (pointList.length == 1) {
          // xmin = JSON.parse(pointList[0])[0]
          // xmax = JSON.parse(pointList[0])[0] + 0.000001
          // ymin = JSON.parse(pointList[0])[1]
          // ymax = JSON.parse(pointList[0])[1] + 0.000001
          x = xmin = JSON.parse(pointList[0].Point)[0]
          y = xmin = JSON.parse(pointList[0].Point)[1]
        } else {
          let X = []
          let Y = []

          pointList.forEach((element) => {
            X.push(JSON.parse(element.Point)[0])
            Y.push(JSON.parse(element.Point)[1])
          })
          // 排序
          X.sort((x, y) => {
            return x - y
          })
          // 排序
          Y.sort((x, y) => {
            return x - y
          })
          // xmin = X[0]
          // ymin = Y[0]
          // xmax = X[X.length - 1]
          // ymax = Y[Y.length - 1]

          x = (X[0] + X[X.length - 1]) / 2
          y = (Y[0] + Y[Y.length - 1]) / 2
        }
        // return [xmin, ymin, xmax, ymax]
        return [x, y]
      },
      //查询打卡点详情
      selectPointInfo(id) {
        let allPointInfo = this.$store.state.allFellableInfo
        let index = allPointInfo.findIndex((x) => x.id == id)
        if (index !== -1) {
          this.pointInfo = JSON.parse(JSON.stringify(allPointInfo[index]))
          if (this.pointInfo.imagess.length > 0) {
            let arr2 = []
            this.pointInfo.imagess.forEach((item) => {
              item.SmallPath = this.$store.state.imgUrl + item.id
              arr2.push(this.$store.state.imgUrl + item.id)
            })
            // this.pointInfo.imagess = arr2;
            this.pointInfo.imgs = arr2
          }
          if (this.patrolPointId !== -1) {
            this.isShowMoveBox = true
            this.$refs.move_box.style.top = this.$store.state.mousePosition.top + 'px'
            this.$refs.move_box.style.left = this.$store.state.mousePosition.left + 'px'
          }
        }
      },
      getMapState() {
        let that = this
        let falg = setInterval(function () {
          if (map) {
            // 关闭循环
            clearInterval(falg)
            that.mapLoading = false
          }
        }, 100)
      },
    },
  }
</script>
<style lang="less" scoped>
  .account {
    height: 100%;
    position: relative;
    .map {
      position: absolute;
      z-index: 99;
      width: calc(100% - 310px);
    }
    .list {
      position: absolute;
      width: 310px;
      right: 0px;
      z-index: 999;
      background: #fff;
      border-left: 1px solid #ebebeb;
      border-top: 1px solid #ebebeb;
      height: 100%;
      .top {
        width: 100%;
        border-bottom: 1px solid #ebebeb;
        height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          margin-left: 16px;
          font-weight: bold;
        }
      }
      .search {
        padding: 15px;
      }
      .table {
        padding: 0px 4px;
        height: calc(100% - 230px);
        overflow: auto;
        .check_all {
          display: flex;
          align-items: center;
          padding: 4px 16px;
          margin-bottom: 16px;
          width: calc(100% - 40px);
          border-bottom: 2px solid #dcdfe6;
          position: absolute;
          background-color: #fff;
          z-index: 999;
        }
        .item {
          padding: 4px 16px;
          word-break: break-all;
          border-bottom: 1px solid #dcdfe6;
          margin-bottom: 16px;

          .task_name {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            cursor: pointer;
            width: 190px;
            margin-left: 8px;
          }
        }
      }
      .page {
        text-align: center;
      }
      /deep/ .el-dialog__header {
        padding: 10px;
        background-color: #5bacf0;
      }
      /deep/ .el-dialog__title {
        color: #fff;
      }
      /deep/ .el-dialog__body {
        padding: 15px;
      }
      /deep/ .el-dialog__footer {
        padding: 0px 10px 10px 10px;
      }
    }
    .patrol_info_list {
      position: absolute;
      width: 310px;
      right: 310px;
      z-index: 999;
      background: #fff;
      border-left: 1px solid #ebebeb;
      border-top: 1px solid #ebebeb;
      height: 100%;
      overflow: auto;
      .top {
        width: 100%;
        border-bottom: 1px solid #ebebeb;
        height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: sticky;
        top: 0px;
        background-color: #fff;
        .title {
          margin-left: 16px;
          font-weight: bold;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .close {
          height: 100%;
          padding: 0 12px;
          border-left: 1px solid #ebebeb;
          display: flex;
          align-items: center;
          color: #858585;
          transition: all 0.3s ease;
        }
        .close:hover {
          color: #fff;
          background-color: #e81123;
        }
      }
      .table {
        margin-top: 16px;
        padding: 0px 4px;
        height: calc(100% - 87px);
      }
      .page {
        text-align: center;
      }
      .card {
        border-bottom: 1px solid #dcdfe6;
        .item {
          padding: 8px;
          display: flex;
          justify-content: space-between;
          .time {
            margin-top: 8px;
            color: #686868;
            font-size: 14px;
          }
          .index {
            width: 25px;
            height: 25px;
            border: 1px solid #dcdfe6;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 4px;
          }
        }
      }
    }
    .move_box {
      position: fixed;
      top: 645px;
      left: 568px;
      // min-height: 100px;
      // width: 100px;
      z-index: 100;
      background-color: rgba(18, 150, 219, 0.8);
      color: #fff;
      padding: 8px;
      border-radius: 10px;
    }

    /deep/ .el-divider--horizontal {
      margin: 8px 0;
    }
    /deep/ .el-dialog__close {
      color: #fff;
    }
    /deep/ .el-dialog__title {
      color: #fff;
    }
    /deep/ .el-dialog__footer {
      padding: 0px 10px 10px 10px;
    }
    /deep/ .el-dialog__header {
      padding: 10px;
      background-color: #5bacf0;
    }
    /deep/ .el-dialog__headerbtn {
      top: 15px;
    }
    /deep/ .el-dialog__body {
      padding: 15px;
    }
  }
</style>
